var _classCallCheck = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/1/Terralego/Customers/fedescot/fedescot-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "@babel/runtime/regenerator", "@babel/runtime/helpers/asyncToGenerator", "@babel/runtime/helpers/defineProperty", "query-string", "./log", "../../../utils/jwt"], b);else if ("undefined" != typeof exports) b(exports, require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/asyncToGenerator"), require("@babel/runtime/helpers/defineProperty"), require("query-string"), require("./log"), require("../../../utils/jwt"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a.regenerator, a.asyncToGenerator, a.defineProperty, a.queryString, a.log, a.jwt), a.api = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c, d, e, f, g) {
  "use strict";

  var j = require("@babel/runtime/helpers/interopRequireDefault");

  function h(a, b) {
    var c = Object.keys(a);

    if (Object.getOwnPropertySymbols) {
      var d = Object.getOwnPropertySymbols(a);
      b && (d = d.filter(function (b) {
        return Object.getOwnPropertyDescriptor(a, b).enumerable;
      })), c.push.apply(c, d);
    }

    return c;
  }

  function i(a) {
    for (var b, c = 1; c < arguments.length; c++) {
      b = null == arguments[c] ? {} : arguments[c], c % 2 ? h(b, !0).forEach(function (c) {
        (0, d.default)(a, c, b[c]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : h(b).forEach(function (c) {
        Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
      });
    }

    return a;
  }

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = a.Api = a.buildHeaders = a.DEFAULT_HEADERS = a.EVENT_SUCCESS = a.EVENT_FAILURE = a.DELETE = a.PATCH = a.PUT = a.POST = a.GET = void 0, b = j(b), c = j(c), d = j(d), e = j(e), f = j(f);
  var k = "GET";
  a.GET = k;
  a.POST = "POST";
  a.PUT = "PUT";
  a.PATCH = "PATCH";
  a.DELETE = "DELETE";
  var l = "failure";
  a.EVENT_FAILURE = l;
  var m = "success";
  a.EVENT_SUCCESS = m;
  var n = {
    "Content-Type": "application/json"
  };
  a.DEFAULT_HEADERS = n;

  var o = function o(a, b) {
    var c = i({}, a),
        d = global.localStorage.getItem("tf:auth:token");
    return d && (0, g.checkTokenValidity)(d) && (c.Authorization = "JWT ".concat(d)), b instanceof FormData && delete c["Content-Type"], c;
  };

  a.buildHeaders = o;

  var p =
  /*#__PURE__*/
  function () {
    function p() {
      _classCallCheck(this, p);

      (0, d.default)(this, "host", "/"), (0, d.default)(this, "listeners", []);
    }

    _createClass(p, [{
      key: "request",
      value: function request(a) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref$method = _ref.method,
            g = _ref$method === void 0 ? k : _ref$method,
            d = _ref.querystring,
            e = _ref.body,
            _ref$headers = _ref.headers,
            h = _ref$headers === void 0 ? n : _ref$headers,
            _ref$responseType = _ref.responseType,
            i = _ref$responseType === void 0 ? "json" : _ref$responseType,
            _ref$rawResponse = _ref.rawResponse,
            j = _ref$rawResponse === void 0 ? !1 : _ref$rawResponse;

        var l = this;
        return (0, c.default)(
        /*#__PURE__*/
        b.default.mark(function c() {
          var k, m, n;
          return b.default.wrap(function (b) {
            for (;;) {
              switch (b.prev = b.next) {
                case 0:
                  return k = l.buildUrl({
                    endpoint: a,
                    querystring: d
                  }), (0, f.default)("request start: ", k), b.next = 4, fetch(k, {
                    method: g,
                    headers: o(h, e),
                    body: e instanceof FormData ? e : JSON.stringify(e)
                  });

                case 4:
                  if (m = b.sent, (0, f.default)("request end: ", k), !(200 > m.status || 299 < m.status)) {
                    b.next = 10;
                    break;
                  }

                  return b.next = 9, l.handleError(m, i);

                case 9:
                  throw b.sent;

                case 10:
                  return b.next = 12, l.handleSuccess(m, i);

                case 12:
                  return n = b.sent, b.abrupt("return", j ? {
                    result: n,
                    response: m
                  } : n);

                case 14:
                case "end":
                  return b.stop();
              }
            }
          }, c);
        }))();
      }
    }, {
      key: "buildUrl",
      value: function buildUrl(_ref2) {
        var a = _ref2.endpoint,
            b = _ref2.querystring;
        return "".concat(this.host, "/").concat(a.replace(/\/+/g, "/")).concat(b ? "?".concat(e.default.stringify(b)) : "");
      }
    }, {
      key: "handleError",
      value: function handleError(a, d) {
        var e = this;
        return (0, c.default)(
        /*#__PURE__*/
        b.default.mark(function c() {
          var f;
          return b.default.wrap(function (b) {
            for (;;) {
              switch (b.prev = b.next) {
                case 0:
                  return f = new Error(a.statusText), f.status = a.status, b.prev = 2, b.next = 5, a[d]();

                case 5:
                  f.data = b.sent, b.next = 11;
                  break;

                case 8:
                  b.prev = 8, b.t0 = b["catch"](2), console.log(b.t0);

                case 11:
                  return e.fire(l, a), b.abrupt("return", f);

                case 13:
                case "end":
                  return b.stop();
              }
            }
          }, c, null, [[2, 8]]);
        }))();
      }
    }, {
      key: "handleSuccess",
      value: function handleSuccess(a, d) {
        var e = this;
        return (0, c.default)(
        /*#__PURE__*/
        b.default.mark(function c() {
          var f;
          return b.default.wrap(function (b) {
            for (;;) {
              switch (b.prev = b.next) {
                case 0:
                  return b.prev = 0, b.next = 3, a[d]();

                case 3:
                  f = b.sent, b.next = 9;
                  break;

                case 6:
                  b.prev = 6, b.t0 = b["catch"](0), console.log(b.t0);

                case 9:
                  return e.fire(m, a), b.abrupt("return", f);

                case 11:
                case "end":
                  return b.stop();
              }
            }
          }, c, null, [[0, 6]]);
        }))();
      }
    }, {
      key: "on",
      value: function on(a, b) {
        var _this = this;

        var c = {
          eventName: a,
          callback: b
        };
        return this.listeners.push(c), function () {
          var a = _this.listeners.findIndex(function (a) {
            return a === c;
          });

          -1 < a && _this.listeners.splice(a, 1);
        };
      }
    }, {
      key: "fire",
      value: function fire(a, b) {
        this.listeners.forEach(function (c) {
          c.eventName === a && c.callback && "function" == typeof c.callback && c.callback(b);
        });
      }
    }]);

    return p;
  }();

  a.Api = p;
  var q = new p();
  a.default = q;
});